const getPassengerCountForAddOns = ({ passengers = {}, addOn }) => {
  if (addOn?.usageType !== 'customer') {
    return 1
  }

  return Object.values(passengers).reduce((num, passengerType) => {
    const count =
      passengerType.code !== 'infant' && passengerType.count
        ? +passengerType.count
        : 0

    return num + count
  }, 0)
}

export default getPassengerCountForAddOns
